/**
 * Route registry — signing/NDA (B✕): route registrations for the signing/NDA
 * module, which is NOT part of the Dyrejournal build (decision 2026-07-05,
 * manifest §9).
 *
 * app.js maps these into the routers with the standard AsyncRoute props.
 * Entry shape: { path, getComponent, props? } — same contract as
 * routes-other.js. The Dyrejournal-repo export replaces this file with an
 * empty stub (`export const signingPublicRoutes = []; export default [];`)
 * and removes the imported route/component files.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */

/* eslint-disable max-len */

// Rendered inside the secondary /tv + /public router.
export const signingPublicRoutes = [
    { path: '/public/sign/:token', getComponent: () => import('../routes/public/sign').then(module => module.default) },
    { path: '/public/verify-signature', getComponent: () => import('../routes/public/verifySignature').then(module => module.default) },
];

// Rendered inside the main router.
export default [
    // Form signing inbox (component-as-route; was statically imported in app.js,
    // now lazy like every other registry route)
    { path: '/signing-requests', getComponent: () => import('../components/formSigningRequest').then(module => module.default) },

    { path: '/signrequest', getComponent: () => import('../routes/signRequest').then(module => module.default) },
    { path: '/signrequest/new', getComponent: () => import('../routes/signRequest/new').then(module => module.default) },
    { path: '/signrequest/:id', getComponent: () => import('../routes/signRequest/view').then(module => module.default) },

    { path: '/admin/nda', getComponent: () => import('../routes/admin/nda').then(module => module.default) },
];
